import {
	MeratusChartererExpenseAccountCodes,
	getMeratusAccountCodeOptions,
} from '@shared/utils/meratus';

const getMeratusReceivableAccountCodeItem = (editable = true) => ({
	key: 'accountCodeOverride',
	label: 'Account',
	editable,
	type: 'select' as const,
	options: getMeratusAccountCodeOptions(MeratusChartererExpenseAccountCodes),
});

export default getMeratusReceivableAccountCodeItem;
